export const environment = {
  production: false,
  url: 'https://automap.terminology.tools',
  ga_code: '',
  version: require('../../package.json').version,
};
